import { ApplicationStore } from '../states'

export const updateClientSecret: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    clientSecret: payload,
  }
}

export const removeClientSecret: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.clientSecret
  return {
    ...newState,
  }
}
